import { Paper, TablePagination } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { baseURL } from "../http/config";

export const CustomTablePagination = ({pagination}) => {
  const [statePage, setStatePage] = useState(JSON.parse(localStorage.getItem("paginationPage")) || 0);

  useEffect(() => {
    console.log("PAGE", statePage)
    localStorage.setItem("paginationPage", statePage);
  }, [statePage])

  useEffect(() => {
    localStorage.setItem("paginationPage", 0);
  }, [window.location.pathname])

  const removeBaseUrl = (text) => {
    const baseUrl = baseURL();
    const updatedText = text?.includes(baseUrl) ? text?.replace(baseUrl, "") : text;
    return updatedText;
  }
  
  return (
    <Paper>
      {console.log(pagination, "pagination12", statePage)}
      <TablePagination
        rowsPerPageOptions={10}
        component="div"
        count={pagination.count}
        rowsPerPage={10}
        page={statePage}
        onPageChange={(event, newPage) => {
          pagination.tablePagination(newPage > statePage ? removeBaseUrl(pagination.next) : removeBaseUrl(pagination.previous));
          setStatePage(newPage);
        }}
      />
    </Paper>
  );
};

export default TablePagination;
